import { Employer } from '@backrs_ui/common-ui';

import { SEARCH_CATEGORIES } from '@backrs_ui/grow-ui/src/pages/Search/search.filters';
import { SearchCategory } from '@backrs_ui/grow-ui/src/pages/Search/search.types';
import { transformSearchResultsToNuggets } from '@backrs_ui/grow-ui/src/pages/Search/search.util';
import { useSearchForEmployerResourcesQuery } from '@backrs_ui/grow-ui/src/redux/employer/employer.api';

export const useFetchResourcesSectionData = (
  employer: Employer,
  selectedTypes: SearchCategory[] = [],
) => {
  const defaultTypes = [
    SEARCH_CATEGORIES.RESOURCES_NUGGET_VIDEO,
    SEARCH_CATEGORIES.RESOURCES_NUGGET_BOOK,
    SEARCH_CATEGORIES.RESOURCES_NUGGET_ARTICLE,
  ];

  const typesToSend = selectedTypes.length > 0 ? selectedTypes : defaultTypes;

  const { data, isLoading } = useSearchForEmployerResourcesQuery(
    {
      sponsor_id: 9999, // TODO: use real sponsor id
      types: typesToSend,
    },
    {
      skip: !employer.name,
    },
  );

  const resources = data ? transformSearchResultsToNuggets(data.results) : { nuggets: [] };

  return { resources: resources.nuggets, isLoading };
};
